import eSystemControllerTypes from '../eControllerTypes';

export default {
  EBRCT_FORM: `${eSystemControllerTypes.ECT_BUG_REPORT}__form`,
  EBRCT_SUBMIT_SUCCESS: `${eSystemControllerTypes.ECT_BUG_REPORT}__submit_success`,
}
